import React from 'react';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PropTypes from 'prop-types';

const TitleBar = ({ onClose, title }) => {
  return (
    <AppBar
      elevation={1}
      sx={{
        alignItems: 'center',
        backgroundColor: 'surface.white',
        flexDirection: 'row',
        justifyContent: 'space-between',
        px: 3,
        zIndex: 1200,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          textAlign: 'left',
        }}
      >
        <Typography
          noWrap
          sx={{
            alignSelf: 'flex-start',
            border: 'none',
            fontSize: '1.4rem',
            mb: 0.5,
            mt: 0.5,
            textAlign: 'left',
            textOverflow: 'ellipsis',
          }}
          variant="h6"
        >
          {title}
        </Typography>
      </div>
      <IconButton
        onClick={onClose}
        size="large"
        sx={{
          color: 'graphic.icons',
        }}
      >
        <CloseRoundedIcon />
      </IconButton>
    </AppBar>
  );
};

TitleBar.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string,
};

TitleBar.defaultProps = {
  onClose: () => {},
  title: 'Create New Reconsignment',
};

export default TitleBar;
